import type { IGetDashboardResponse } from "../requests/types";

export interface ICertidoes {
  pendentes: number;
}

export default class Certidoes {
  constructor(readonly response: IGetDashboardResponse | undefined) {}

  handler(): ICertidoes {
    return {
      pendentes: this.response?.certidoes.pendentes || 0
    };
  }
}
